export class AssetRecoSave {
    assetId: number;
    assetRecoId: number;
}